<template>
    <v-btn :block="block" :color="color" :disabled="!clickable" :loading="!clickable">{{text}}</v-btn>
</template>

<script>
export default{
    props:['text', 'clickable', 'color', 'block'],
    data(){
        return{
        }
    }
}
</script>
